<template>
  <div id="mypage-myinfo-template joinstart" class="content-section">
    <article class="board-view-wrap has-allChk" v-if="!isAgree">
      <div class="text-box-section">
        <div class="check-wrap all-Chk">
          <input type="checkbox" class="sr-only" v-model="allAgree" id="allAgree" name="allAgree" true-value="true"
                 false-value="false" title="전체 동의 선택" />
          <label for="allAgree"><span><strong>전체 동의</strong></span></label>
        </div>
        <p class="mt-16 color-gray">본인은 본 “이용약관과 개인정보의 수집·이용 및 제3자 제공 동의서” 내용을 읽고 명확히 이해했으며, 이에 동의합니다.
        </p>
      </div>

      <div class="border-line-box wrap mt-40">
        <!-- 홈페이지 이용약관 동의 -->
        <div class="check-wrap">
          <input type="checkbox" class="sr-only" ref="termAgree" v-model="termAgree" id="termAgree" name="termAgree" true-value="true"
                 false-value="false" title="홈페이지 이용약관 동의 선택" />
          <label for="termAgree"><span><strong>[필수] 홈페이지 이용약관 동의</strong></span></label>
        </div>
        <div class="text-area-wrap mt-16">
          [제 1 장 총 칙]<br>
          <br>
          제 1 조 (목적)<br>
          이 약관은 서울시 50플러스재단, 캠퍼스, 센터 (이하 "재단"이라 함)이 운영하는 웹사이트(이하 “사이트”)에서 제공하는 인터넷 관련 홈페이지 서비스(이하 "서비스")를 이용함에 있어서 사이트와
          이용자 사이의 의무 및 책임사항, 하나의 ID 및 PASSWORD로 통합하여 이용하는데 따른 이용조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.<br>
          <br>
          제 2 조 (약관의 명시 및 개정)<br>
          ① 이 약관은 재단이 인터넷 홈페이지 화면 또는 지면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다. <br>
          ② 재단은 필요에 따라 이 약관을 개정할 수 있으며 변경된 약관은 1항과 같은 방법으로 공지함으로써 효력이 발생합니다. <br>
          ③ 이용자는 변경된 약관에 동의하지 않으실 경우 서비스 이용을 중단하고 본인의 회원등록을 취소할 수 있으며, 변경된 약관의 효력 발생일 이후의 계속적인 서비스 이용은 변경 약관에 동의한 것으로
          간주합니다.<br>
          <br>
          제 3 조 (약관 외 준칙)<br>
          이 약관에 명시되지 않은 사항과 이 약관의 해석은 개인정보보호법, 전기통신기본법, 전기통신사업법, 정보통신망이용촉진및정보보호등에관한법률, 방송통신심의위원회 심의규정, 정보통신 윤리강령, 프로그램
          보호법 등 기타 대한민국의 관련법령과 상관습에 의합니다.<br>
          <br>
          제 4 조 (용어의 정의)<br>
          이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br>
          ① 사이트 : 재단이 서비스를 이용자에게 제공하기 위하여 운영하는 사이트를 말하며, 통합된 하나의 계정(ID 및 PASSWORD)을 이용하여 서비스를 제공받을 수 있는 아래의 사이트를 의미하기도
          합니다.<br>
          1. 서울시 50플러스 재단 공식 홈페이지 : www.50plus.or.kr<br>
          2. 그 외 홈페이지별 하위 도메인 홈페이지 포함(일자리몽땅, 라이프몽땅, 자치구센터)<br>
          ② 이용자 : 재단의 이용약관에 따라 사이트가 제공하는 서비스를 받는 회원 또는 비회원을 말합니다.<br>
          ③ 회원 : 재단의 이용약관에 동의하고, 개인정보를 제공하여 회원으로 등록하고 승인받은 자로서, 재단이 제공하는 로그인 서비스를 이용할 수 있는 자를 말합니다.<br>
          ④ 비회원 : 회원등록을 하지 않고 사이트가 제공하는 서비스를 이용하는 자를 말합니다.<br>
          ⑤ ID(고유번호) : 회원식별과 회원 서비스 이용을 위하여 회원이 신청하고 재단이 승인하는 문자 및 숫자의 조합을 말합니다.<br>
          ⑥ PASSWORD(비밀번호) : 회원이 부여받은 ID와 일치된 회원임을 확인하고 회원의 비밀보호를 위하여 회원 자신이 선정한 문자와 숫자의 조합을 말합니다.<br>
          ⑦ 탈퇴(이용해지) : 회원이 이용계약을 종료시키는 의사표시를 말합니다. <br>
          ⑧ 본 약관에서 정의하지 않은 용어는 개별서비스에 대한 별도 약관 및 이용규정에서 정의 합니다.<br>
          <br>
          <br>
          [제 2 장 서비스의 이용계약]<br>
          <br>
          제 5 조 (신청) <br>
          ① 회원이 되고자하는 이용자는 온라인을 통하여 회원가입 페이지의 ‘동의함’ 체크를 눌러 홈페이지의 본 약관 내용에 대한 동의표시를 합니다.<br>
          ② 본 약관에 동의한 이용자는 재단이 마련한 본인확인 절차를 거치며, 만 14세 미만의 경우는 법정대리인의 동의가 필요합니다.<br>
          ③ 재단과 이용자간의 서비스 이용계약은 본인확인 절차를 거친 이용자가 웹사이트에서 제공하는 양식에 따른 기록을 통해 회원가입을 완료하고, 재단의 승인으로 성립되어 회원의 자격을 취득합니다.<br>
          ④ 이용자는 사이트의 회원 가입화면에서 다음의 서비스를 원하는 경우 선택하여 신청할 수 있습니다.<br>
          1. 수신동의(E-mail / SMS)<br>
          2. 가입동의(서울시 50플러스 재단)<br>
          ⑤ 재단은 제1장 제4조 제1항에 명기한 사이트의 원활한 서비스를 이용하기 위해 필요한 추가정보를 이용자 동의절차를 통해 요구할 수 있습니다.<br>
          <br>
          제 6 조 (계약의 성립) <br>
          ① 재단은 제2장 제1조에서 정한 사항을 정확히 기재하여 이용신청을 하였을 경우 특별한 사정이 없는 한 서비스 이용신청을 승낙합니다.<br>
          ② 재단은 다음 각 호에 해당하는 경우에 한하여 이용신청을 승낙하지 않을 수 있습니다. <br>
          1. 본인인증이 되지 않거나 이미 이용신청중인 타인의 정보와 중복되는 경우<br>
          2. 만14세 미만의 경우, 법정대리인의 동의가 없는 경우<br>
          3. 기타 홈페이지가 정한 회원가입 요건을 충족하지 못하였을 경우<br>
          ③ 재단은 다음 각 항에 해당하는 경우 그 사유가 해소될 때까지 이용계약 성립을 유보 또는 일부 서비스 이용을 제한할 수 있습니다.<br>
          1. 서비스 관련 설비의 용량이 부족한 경우<br>
          2. 기술상 장애 사유가 있는 경우<br>
          3. 기타 재단의 사정상 필요하다고 인정되는 경우<br>
          <br>
          제 7 조 (회원의 유효기간)<br>
          ① 회원의 유효기간은 이용계약의 성립 시부터 이용자의 의사에 의한 계약의 해지 시까지입니다.<br>
          <br>
          제 8 조 (회원에게 제공되는 서비스) <br>
          ① 재단이 제공하는 로그인 서비스를 이용할 수 있습니다.<br>
          ② 재단의 각종 행사 정보를 E-mail을 통해 제공 받을 수 있으며, 각 재단별 발행 뉴스레터를 통해 행사를 홍보 할 수 있습니다.<br>
          ③ 홈페이지 이벤트 참여기회 부여됩니다.<br>
          ④ 배움(특강, 창업교육) <br>
          ⑤ 커뮤니티관리시스템<br>
          ⑥ 가치동행일자리, 취업훈련, 경력인재지원, 채용설명회<br>
          ⑦ 대관관리시스템<br>
          ⑧ 상담관리시스템<br>
          ⑨ 기타 재단 관련 행사 참여 및 정보를 우선적으로 제공해 드립니다.<br>
          <br>
          제 9 조 (통합회원제)<br>
          ① 회원은 통합된 하나의 계정(ID 및 비밀번호)을 통해 본 약관 제1장 제4조 제1항에 명기한 캠퍼스, 센터, 교육 사이트의 서비스를 별도의 회원가입 없이 이용할 수 있습니다.<br>
          ② 통합ID는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경하고자 하는 경우에는 해당 회원등록을 탈퇴(해지)하고 재가입해야 합니다. <br>
          (※단, 탈퇴(해지)한 회원은 기존 통합ID로 서비스를 이용할 수 없습니다.)<br>
          ③ 회원은 등록된 본인의 회원정보가 변경된 경우, 즉시 변경된 내용으로 회원정보를 수정하여야 하며, 재단은 회원이 변경사항을 수정하지 아니하여 발생하는 불이익에 대하여 책임지지 않습니다.<br>
          ④ 통합ID 분실 시 본인 확인 과정을 거친 후 홈페이지를 통해 통합ID를 확인할 수 있도록 제공합니다.<br>
          ⑤ 비밀번호 분실 시 본인 확인 과정을 거친 후 가입 시 기입한 이메일 주소를 통해 임시 비밀번호를 제공합니다.<br>
          <br>
          <br>
          [제 3 장 계약 해지 및 서비스 이용제한 ]<br>
          <br>
          제 10 조 (회원탈퇴 및 자격 상실) <br>
          ① 회원은 회원가입 이후 홈페이지에서 제공하는 서비스를 제공받을 의사를 철회하고자 하는 경우에는 언제든지 “회원탈퇴” 메뉴를 이용하여 탈퇴를 요청할 수 있으며 재단은 즉시 회원탈퇴를 처리합니다.
          다만, 재단에 제공한 수강정보, 결제정보, 커뮤니티, 일자리 정보 등 관련정보는 회원의 별도 삭제처리 요청이 없을 경우 계속하여 제공됩니다.<br>
          * 전자상거래 등에서의 소비자보호에 관한 법률 제 6조에 의거 성명·주소·전자우편주소 등 거래의 주체를 식별할 수 있는 정보에 한하여 이용자가 개인정보의 이용에 관한 동의를 철회하는 경우에도
          「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 대통령령으로 정하는 개인정보보호와 관련된 법률의 규정에도 불구하고 이를 보존할 수 있다<br>
          1. 표시·광고에 관한 기록: 6개월<br>
          2. 계약 또는 청약철회 등에 관한 기록: 5년<br>
          3. 대금결제 및 재화등의 공급에 관한 기록: 5년<br>
          4. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년<br>
          (개인정보의 이용에 관한 동의를 철회한 소비자의 거래기록 및 개인정보를 보존하는 경우에는 개인정보의 이용에 관한 동의를 철회하지 아니한 소비자의 거래기록 및 개인정보와 별도로 보존할 것)<br>
          ② 회원이 다음 각 호의 사유에 해당하는 경우 재단은 회원자격을 제한 및 정지, 취소시킬 수 있습니다.<br>
          1. 다른 사람의 명의를 사용하여 신청하였을 경우<br>
          2. 신청서의 내용을 허위로 기재한 사실이 발견된 경우<br>
          3. 다른 사람의 홈페이지 서비스 이용을 방해하거나 다른 사람의 정보를 도용하는 등의 행위를 하였을 경우<br>
          4. 홈페이지를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우<br>
          5. 사회의 안녕 질서 또는 미풍양속을 저해할 목적으로 신청하였을 경우<br>
          ③ 재단은 각 홈페이지별 회원을 통합 운영하고 있으므로 통합회원을 탈퇴하면 재단에서 서비스 중인 홈페이지에 로그인할 수 없습니다. <br>
          ④ 개별 홈페이지가 폐쇄 또는 양도되었을 경우에는 서비스 대상만 삭제되며 개별 홈페이지를 통해 회원가입을 한 회원을 대상으로 통합회원 탈퇴가 이루어지지는 않습니다. <br>
          <br>
          제 11 조 (계약사항의 변경) <br>
          ① 회원은 회원정보관리를 통해 언제든지 자신의 정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.<br>
          ② 회원은 이용신청 시 기재한 사항이 변경되었을 때에는 온라인으로 변경사항을 수정하여야 합니다.<br>
          ③ 제2항의 변경사항을 재단에 알리지 않아 발생한 불이익에 대하여 재단은 책임지지 않습니다.<br>
          <br>
          <br>
          [제 4 장 계약당사자의 의무]<br>
          <br>
          제 12 조 (개인정보 보호) <br>
          ① 재단은 회원 가입 시 회원 서비스 제공 이행에 필요한 최소한의 정보를 수집합니다.<br>
          ② 재단은 회원의 개인 식별이 가능한 정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.(회원가입 약관을 읽고 "동의함"버튼을 누른 후 회원 본인이 직접 신청서를 작성하시면 이 약관에
          동의한 것으로 간주합니다.)<br>
          ③ 제공된 개인정보는 다음의 경우를 제외하고는 회원의 동의 없이 이용할 수 없으며 제3자에게 제공하지 않습니다. <br>
          1. 관계 법령에 의하여 수사상의 목적으로 관계기관으로부터 요구가 있는 경우<br>
          2. 방송통신심의위원회의 요청이 있는 경우<br>
          3. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우<br>
          ④ 회원가입에 대한 동의 철회, 열람 또는 정정 요구 등 회원이 수정한 정보는 수정절차가 완료된 시점부터 바로 적용됩니다.<br>
          ⑤ 개인정보의 수집 목적 또는 제공받은 목적이 달성되면, 개인정보를 즉시 파기합니다. 단, 별도 탈퇴 신청없이 통합회원만 탈퇴한 경우 및 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는
          예외로 합니다.<br>
          ⑥ 재단은 개인정보 보호와 관련하여 이용자의 의견과 불만을 접수할 수 있는 창구를 개설하고 있습니다. 개인정보와 관련한 불만이 있으신 분은 재단 개인정보보호 책임자 또는 개인정보보호 담당자에게
          의견을 주시면 접수 즉시 조치하여 처리결과를 통보하여 드립니다.<br>
          - 서울시50플러스재단 개인정보보호책임자:경영기획본부 이민정 본부장(mjl@50plus.or.kr) T.02-460-5001 <br>
          - 서울시50플러스재단 개인정보보호담당자:정보화지원팀 김정현 주임(jhkim@50plus.or.kr) T. 02-460-5062  F. 02-734-8332<br>
          <br>
          제 13 조 (재단의 의무) <br>
          1. 재단은 법령과 이 약관이 금지하거나 공서 양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다하여야 합니다. <br>
          2. 재단은 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보안에 대하여 최고의 안전 조치를 강구하여 이용자의 정보보안에 최선을 다해야 할 의무가 있습니다. <br>
          3. 재단은 회원이 제기하는 불편, 불만 사항에 대해 정당하다고 판단할 경우 즉시 처리해야 합니다. <br>
          <br>
          제 14 조 (회원의 의무)<br>
          ① 회원은 관계법령, 이 약관의 규정, 이용안내 등 회사가 통지하는 사항을 준수하여야 하며, 기타 재단에 방해되는 행위를 하여서는 안 됩니다. <br>
          ② 가입 신청자가 재단 서비스 가입 절차를 완료하는 순간부터 귀하는 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 인터넷 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원에게
          있습니다. <br>
          ③ 회원은 ID 및 PASSWORD 등과 같이 서비스 이용에 필요한 정보를 관리할 의무가 있습니다. 회원의 부주의로 분실한 정보에 대해서는 재단이 책임지지 않습니다.<br>
          ④ 회원은 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안 됩니다.<br>
          1. 서비스에서 얻은 정보를 재단의 사전 승낙 없이 회원의 이용 이외 목적으로 복제하거나 출판 및 방송 등에 사용하거나 제3자에게 제공하는 행위 <br>
          2. 재단의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위 <br>
          3. 정보통신설비의 오동작 및 정보 등의 파괴 혼란을 유발시키는 컴퓨터 바이러스 감염자료를 등록 또는 유포하는 행위 <br>
          4. 범죄와 결부된다고 객관적으로 판단되는 행위 <br>
          5. 재단 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br>
          6. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서 양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위<br>
          7. 기타 관계법령이나 재단이 정한 이용조건에 위배되는 행위 <br>
          <br>
          제 15 조 (회원에 대한 통지)<br>
          ① 재단이 회원에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소 등으로 할 수 있습니다.<br>
          ② 재단은 회원 전체에 대한 통지의 경우 7일 이상 재단 홈페이지의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.<br>
          <br>
          <br>
          <br>
          <br>
          <br>
          [제 5 장 서비스의 이용]<br>
          <br>
          제 16 조 (정보의 제공) <br>
          ① 재단이 회원에게 제공하는 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.<br>
          ② 재단은 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 재단은 홈페이지의 게시판 등을
          통해 사전에 회원에게 해당 내용을 통지합니다. 다만, 재단이 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.<br>
          ③ 재단은 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련 정보 및 고객문의 등에
          대한 답변 등을 제외하고는 언제든지 전자우편에 대해서 수신 거부를 할 수 있습니다.<br>
          ④ 재단은 서비스의 운영과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편을 수신한 회원은 수신거절을 재단에게 할 수 있습니다.<br>
          <br>
          제 17 조 (서비스의 변경) <br>
          ① 재단은 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.<br>
          ② 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 등을 그 변경 전에 홈페이지에 게시판에 게시하여야 합니다.<br>
          <br>
          제 18조 (서비스 이용/이용대금)<br>
          ① 이용자가 서비스를 이용하기 위해서는 재단이 공지사항에 게시하거나 해당서비스 이용안내에서 제시하는 절차와 내용을 준수하여야 합니다. 서비스이용신청은 반드시 실명으로 하여야 합니다. <br>
          ② 서비스 이용대금은 재단이 공지사항에 게시하거나 해당 서비스 이용안내에서 제시하는 바에 따릅니다. 재단이 제공하는 서비스는 그 이용대금을 별도 게시하거나 제시하지 않는 한 무료로 합니다.<br>
          <br>
          제 19조 (서비스 이용계약의 성립)<br>
          ① 서비스 이용계약은 이용자의 서비스 이용 신청 시 성립합니다. 다만 아래의 경우 재단은 서비스 이용 계약을 취소할 수 있습니다. <br>
          1. 신청 내용에 허위, 기재누락, 오기가 있는 경우<br>
          2. 기타 서비스를 제공하는 것이 "서울시50플러스재단"의 기술상 현저히 지장이 있다고 판단하는 경우<br>
          <br>
          제 20 조 (회원의 게시물) <br>
          ① 재단은 회원이 게시하거나 등록하는 서비스의 내용물이 다음 각 항에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있습니다.<br>
          1. 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 경우<br>
          2. 공공질서 및 미풍양속에 위반되는 경우<br>
          3. 범죄적 행위에 결부된다고 인정되는 경우<br>
          4. 재단의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 경우<br>
          5. 재단에서 규정한 게시기간을 초과한 경우<br>
          6. 회원이 재단(홈페이지)의 게시판에 음란물을 게재하거나 음란사이트를 링크하는 경우<br>
          7. 기타 관계법령에 위반된다고 판단되는 경우<br>
          <br>
          제 21 조 (게시물의 저작권) <br>
          ① 게시물에 대한 권리와 책임은 게시자에게 있으며, 재단은 게시자의 동의 없이는 이를 사이트 내 게재 이외의 영리목적으로 사용할 수 없습니다. 단, 비영리적인 경우에는 그러하지 아니하며 또한 재단은
          사이트 내의 게재권을 갖습니다.<br>
          ② 회원이 서비스 내에 게시하는 게시물은 검색결과 내지 서비스 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이
          경우, 재단은 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당 게시물에 대한 삭제, 검색결과 제외 등의 조치를 취할 수 있습니다.<br>
          ③ 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 등 서비스에 게재된 자료를 상업적으로 사용할 수 없습니다.<br>
          <br>
          <br>
          [제 6 장 기 타]<br>
          <br>
          제 22 조 (손해배상)<br>
          ① 재단은 무료로 제공되는 서비스 이용과 관련하여 회원에게 어떠한 손해가 발생하더라도 동 손해가 재단의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부담하지 않습니다.<br>
          <br>
          제 23 조 (면책조항)<br>
          ① 재단은 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.<br>
          ② 재단은 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.<br>
          ③ 재단은 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖에 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.<br>
          ④ 재단은 회원이 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관해서는 책임을 지지 않습니다.<br>
          ⑤ 회원이 발송한 메일 내용에 대한 법적인 책임은 이용자에게 있습니다.<br>
          <br>
          제 24 조 (관할법원)<br>
          본 서비스와 관련되는 분쟁에 대해 소송이 제기될 경우, 재단의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.<br>
          <br>
          - 부 칙 -<br>
          이 약관은 2017년 11월 25일부터 시행합니다.<br>
          최종 갱신일 : 2026년 10월 02일<br>
          <br>
          ※ 귀하께서는 이용약관에 거부할 권리가 있습니다.<br>
          ○ 거부에 따른 불이익 : 동의를 거부하실 경우 회원가입이 불가능함을 알려드립니다.
        </div>
        <!-- // 홈페이지 이용약관 동의 -->

        <!-- 개인정보 수집 및 이용 동의 -->
        <div class="check-wrap mt-40">
          <input type="checkbox" class="sr-only" ref="privacyAgree" v-model="privacyAgree" id="privacyAgree" name="privacyAgree" true-value="true"
                 false-value="false" title="개인정보 수집 및 이용 동의 필수사항 선택" />
          <label for="privacyAgree"><span><strong>[필수] 개인정보 수집 및 이용 동의(필수사항)</strong></span></label>
        </div>
        <div class="text-area-wrap mt-16">
          <strong>[수집・이용하려는 개인정보의 항목]</strong><br>
          <strong>[필수]</strong> 성명, 성별, 생년월일, 아이디, 주소, 연락처, e-mail주소, 나의 관심50+<br>
          <strong>[개인정보의 수집・이용 목적]</strong><br>
          ・회원관리 및 양질의 서비스 제공 및 민원사무 처리<br>
          (교육 운영을 위한 신청자관리, CRM 및 만족도조사 업무수행)<br>
          ・관리시스템(일자리, 수강, 커뮤니티, 대관, 상담) 이용신청서 접수 및 심사<br>
          <strong>[개인정보 이용 및 보유기간]</strong><br>
          <span style="color: blue; font-weight: bold;">회원 탈퇴 시 까지</span><br>
          ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다.<br>
          ○ 거부에 따른 불이익 : 동의를 거부하실 경우 회원가입이 불가능함을 알려드립니다.
        </div>
        <!-- //개인정보 수집 및 이용 동의 -->

        <!-- 개인정보 수집 및 이용 동의 -->
        <div class="check-wrap mt-40">
          <input type="checkbox" class="sr-only" v-model="privacyAgree2" id="privacyAgree2" name="privacyAgree2" true-value="true"
                 false-value="false" title="개인정보 수집 및 이용 동의 선택사항 선택" />
          <label for="privacyAgree2"><span><strong>[선택] 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능)</strong></span></label>
        </div>
        <div class="text-area-wrap mt-16">
          <strong>[수집·이용하려는 개인정보의 항목]</strong><br>
          <strong>[선택]</strong> 성명, 성별, 생년월일, 아이디, 이메일 주소, 연락처, 발송 동의여부<br>
          <strong>[개인정보의 수집·이용 목적]</strong><br>
          ・ 웹 소식지 발송<br>
          <strong>[개인정보 이용 및 보유기간]</strong><br>
          <span style="color: blue; font-weight: bold;">회원 탈퇴 시</span><br>
          ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다.<br>
          ○ 거부에 따른 불이익 : 일자리, 교육, 행사 소식 등 정보 제공이 불가능함을 알려드립니다.
        </div>
        <!-- // 개인정보 수집 및 이용 동의 -->

        <!-- 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능) -->
        <div class="check-wrap mt-40">
          <input type="checkbox" class="sr-only" v-model="privacyAgree3" id="privacyAgree3" name="privacyAgree3" true-value="true"
                 false-value="false" title="개인정보 수집 및 이용 동의 선택사항 선택" />
          <label for="privacyAgree3"><span><strong>[선택] 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능)</strong></span></label>
        </div>
        <div class="text-area-wrap mt-16">
          <strong>[수집·이용하려는 개인정보의 항목]</strong><br>
          <strong>[선택]</strong> 성명, 성별, 생년월일, 아이디, 이메일 주소, 연락처, 발송 동의여부<br>
          <strong>[개인정보의 수집·이용 목적]</strong><br>
          ・ ‘일자리, 교육, 행사소식 등 정보제공’을 위한 문자, 카카오톡 메시지 발송<br>
          <strong>[개인정보 이용 및 보유기간]</strong><br>
          <span style="color: blue; font-weight: bold;">회원 탈퇴 시</span><br>
          ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다.<br>
          ○ 거부에 따른 불이익 : 일자리, 교육, 행사 소식 등 정보 제공이 불가능함을 알려드립니다.
        </div>
        <!-- // 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능) -->

        <!-- 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능) -->
        <div class="check-wrap mt-40">
          <input type="checkbox" class="sr-only" v-model="privacyAgree4" id="privacyAgree4" name="privacyAgree4" true-value="true"
                  false-value="false" title="개인정보 수집 및 이용 동의 선택사항 선택" />
          <label for="privacyAgree4"><span><strong>[선택] 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능)</strong></span></label>
        </div>
        <div class="text-area-wrap mt-16">
          <strong>[수집·이용하려는 개인정보의 항목]</strong><br>
          <strong>[선택]</strong> 가입경로, 가입동기 및 희망분야, 사진 이용자의 사용언어, 브라우저 종류 및 OS, 화면 색상 및 크기, 방문일시<br>
          <strong>[개인정보의 수집·이용 목적]</strong><br>
          ・ 교육 운영을 위한 신청자 관리, CRM 및 만족도 조사 업무수행<br>
          ・ 관리시스템 이용신청서 접수 및 심사<br>
          (일자리, 수강, 커뮤니티, 대관, 상담)<br>
          <strong>[개인정보 이용 및 보유기간]</strong><br>
          <span style="color: blue; font-weight: bold;">회원 탈퇴 시</span><br>
          ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다.<br>
          ○ 거부에 따른 불이익 : 일자리, 교육, 행사 소식 등 정보 제공이 불가능함을 알려드립니다.
        </div>
        <!-- // 개인정보 수집 및 이용 동의 (선택사항, 동의거부 가능) -->

        <!-- 개인정보의 제3자 제공 동의 -->
        <div class="check-wrap mt-40">
          <input type="checkbox" class="sr-only" ref="thirdPartyAgree" v-model="thirdPartyAgree" id="thirdPartyAgree" name="thirdPartyAgree" true-value="true"
                  false-value="false" title="개인정보의 제3자 제공 동의 선택" />
          <label for="thirdPartyAgree"><span><strong>[필수] 개인정보의 제3자 제공 동의</strong></span></label>
        </div>
        <div class="text-area-wrap mt-16">
          <strong>[제공되는 개인정보 항목]</strong><br>
          ・성명, 성별, 생년월일, 아이디, 주소, 연락처, e-mail주소, 나의 관심50+<br>
          <strong>[개인정보를 제공 받는 자]</strong><br>
          <span style="color: blue; font-weight: bold;">・서울특별시 및 시민만족도조사 용역 수행기관, 노원50+센터, 동작50+센터, 서대문50+센터
          , 성북50+센터, 금천50+센터, 강서50+센터, 서초50+센터, 강동50+센터, 양천50+센터, 성동50+센터, 강북50+센터, 관악50+센터, 동대문50+센터, 용산50+센터</span><br>
          <strong>[개인정보를 제공 받는 자의 개인정보 이용목적]</strong><br>
          <span style="color: blue; font-weight: bold;">・회원관리 및 양질의 서비스 제공 및 민원사무 처리<br>
            (교육 운영을 위한 신청자관리, CRM 및 만족도조사 업무수행)<br>
            ・관리시스템(일자리, 수강, 커뮤니티, 대관, 상담) 이용신청서 접수 및 심사</span><br>
          <strong>[개인정보를 제공 받는 자의 개인정보 이용 및 보유기간]</strong><br>
          <span style="color: blue; font-weight: bold;">회원 탈퇴 시 까지</span><br>
          ※ 귀하께서는 개인정보 제공 및 활용에 거부할 권리가 있습니다.<br>
          ○ 거부에 따른 불이익 : 동의를 거부하실 경우 회원가입이 불가능함을 알려드립니다.
        </div>
        <!-- // 개인정보의 제3자 제공 동의 -->

        <!-- [필수] 나의 이력서 정보 제공 동의 -->
        <div class="check-wrap mt-40">
          <input type="checkbox" class="sr-only" ref="resumeAgree" v-model="resumeAgree" id="resumeAgree" name="resumeAgree" true-value="true"
                 false-value="false" title="나의 이력서 정보 제공 동의 선택" />
          <label for="resumeAgree"><span><strong>[필수] 나의 이력서 정보 제공 동의</strong></span></label>
        </div>
        <div class="text-area-wrap mt-16">
          <strong>[수집항목]</strong><br>
          ・기본정보(이름, 생년월일, 이메일, 휴대폰, 주소), 학력(최종학력,졸업여부)<br>
          ・이력서 작성 시 추가 작성한 항목<br>
          <strong>[수집 및 이용목적]</strong><br>
          ・이력서 등록을 통한 입사 지원 등 취업활동 서비스 제공, 각종 맞춤형 취업서비스 제공<br>
          <strong>[보관기간]</strong><br>
          ・회원탈퇴 및 이력서 삭제 시
        </div>
        <!-- // [필수] 나의 이력서 정보 제공 동의 -->

      </div>
    </article>
    <div class="button-area flex-end mt-40" v-if="!isAgree">
      <button type="button" class="btn btn-primary btn-md" @click="agreeConfirm" title="다음으로">
        다음으로
      </button>
    </div>


    <div class="table-wrap join-info-wrap" v-if="!loggedIn && isAgree">
      <p class="join-info-text">
        <span class="sr-only">별표</span>
        <span class="must" aria-hidden="true">*</span> 표시는 필수 입력 사항입니다.
      </p>
      <table class="table-body-only mt-16">
        <caption class="ir-text">회원가입 정보입력</caption>
        <colgroup class="pc-cell">
          <col style="width: 160px"/>
          <col/>
        </colgroup>
        <colgroup class="mo-cell">
          <col style="width: 88px"/>
          <col/>
        </colgroup>
        <tbody>
        <tr>
          <th scope="row">
            <label for="loginid">아이디</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span>
          </th>
          <td>
            <div class="input-area wid100p has-button">
                  <input type="text" placeholder="아이디를 입력해 주세요." v-model="loginid" id="loginid" aria-describedby="id-guide" title="아이디 입력"
                     style="text-transform: lowercase;">
                  <button type="button" class="btn btn-primary btn-xsm" @click="confirmId" v-if="aleadyHave" title="아이디 중복확인">
                중복확인
              </button>
            </div>
            <p class="join-info-text mt-16" id="id-guide">* 아이디는 중복확인 후 사용 가능합니다.</p>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <label for="password">비밀번호</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span>
          </th>
          <td>
            <div class="input-area wid100p">
                  <input type="password" placeholder="비밀번호를 입력해 주세요." id="password" v-model="password" aria-describedby="pw-guide" title="비밀번호 입력">
            </div>
            <p class="join-info-text mt-16" id="pw-guide">
              <span class="sr-only">별표</span><span aria-hidden="true">*</span> 비밀번호는 영문(소문자), 숫자, 특수문자 포함 9자 이상 입력해주세요.
            </p>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <label for="passwordconfirm">비밀번호 확인</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span>
          </th>
          <td>
            <div class="input-area wid100p">
                  <input type="password" placeholder="비밀번호를 입력해 주세요." id="passwordconfirm" v-model="passwordConfirm" title="비밀번호 확인 입력">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <label for="name">이름</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span>
          </th>
          <td>
            <div class="input-area wid100p">
                  <input type="text" placeholder="이름을 입력해 주세요." id="name" v-model="name" title="이름 입력">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" id="label-birth">생년
            <br class="mo-only">
            월일 <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span>
          </th>
          <td>
            <div class="input-group phone-group">
              <div class="items1">
                <div class="input-area wid100">
                  <select title="년도 선택" v-model="birthYYYY" id="birthYYYY" aria-labelledby="label-birth birthYYYY">
                    <option value="">년도 선택</option>
                    <option v-for="year in years" :selected="birthYYYY === year" :key="year">{{ year }}</option>
                  </select>
                </div>
              </div>
              <div class="items2">
                <div class="input-area wid100">
                  <select title="월 선택" v-model="birthMM" id="birthMM" aria-labelledby="label-birth birthMM">
                    <option value="">월 선택</option>
                    <option v-for="month in months" :selected="birthMM === month" :key="month">{{ month }}</option>
                  </select>
                </div>
                <div class="input-area wid100">
                  <select title="일 선택" v-model="birthDD" id="birthDD" aria-labelledby="label-birth birthDD">
                    <option value="">일 선택</option>
                    <option v-for="day in days" :selected="birthDD === day" :key="day">{{ day }}</option>
                  </select>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" id="label-gender">성별 <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span></th>
          <td>
            <div class="flex gap10" role="group" aria-labelledby="label-gender">
              <label class="radio-item" v-for="(key, value) in genderList" :key="value">
                <input type="radio" class="sr-only" name="inlineRadioOptions" v-model="gender" :value="value" :aria-label="'성별, ' + key">
                <span class="custom-radio"></span>
                {{ key }}
              </label>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><label for="email1">이메일</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span></th>
          <td>
            <div class="input-group email-group">
              <div class="items1">
                <div class="input-area wid120">
                  <input type="text" placeholder="1234" v-model="email1" id="email1" title="이메일 계정">
                </div>
                <div class="dash">@</div>
              </div>
              <div class="items2">
                <div class="input-area wid120">
                  <select id="emailSelectBox" v-model="email2" v-on:change="emailChange" title="이메일 도메인 선택">
                    <option value="">선택</option>
                    <option v-for="list in emailList" :value="list" :key="list">{{ list }}</option>
                    <option value="etc">직접입력</option>
                  </select>
                </div>
                <div class="input-area wid120">
                  <input type="text" placeholder="email.com" id="emailSelectBoxDirect" v-model="etcEmailAddress"
                         title="이메일 도메인 직접입력" v-if="email2 === 'etc'">
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" id="label-phone">휴대폰 <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span></th>
          <td>
            <div class="input-group phone-group" role="group" aria-labelledby="label-phone">
              <div class="items1">
                <div class="input-area wid120" v-if="this.sessionHp === ''">
                  <select title="휴대폰 앞자리" id="phone1" v-model="phone1">
                    <option>010</option>
                  </select>
                </div>
                <div class="input-area wid120" v-if="this.sessionHp !== ''">
                  <input type="text" title="휴대폰 앞자리" placeholder="1234" v-model="phone1"
                         v-bind:readonly="this.sessionHp === '' ? false : true">
                </div>
                <div class="dash" aria-hidden="true">-</div>
              </div>
              <div class="items2">
                <div class="input-area wid120">
                  <input type="text" placeholder="1234" v-model="phone2" title="휴대폰 중간자리"
                         v-bind:readonly="this.sessionHp === '' ? false : true">
                </div>
                <div class="dash" aria-hidden="true">-</div>
                <div class="input-area wid120">
                  <input type="text" placeholder="1234" v-model="phone3" title="휴대폰 뒷자리"
                         v-bind:readonly="this.sessionHp === '' ? false : true">
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <label for="postcode">주소 <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span></label>
          </th>
          <td>
            <div class="address-wrap">
              <div class="input-group post-code">
                <div class="input-area wid200">
                  <input type="text" id="postcode" v-model="zipcode" readonly title="우편번호">
                </div>
                <button type="button" class=" btn btn-primary btn-xsm" id="findPostCode" ref="findPostCode" title="우편번호 검색"
                        @click="findAddress">
                  우편번호 검색
                </button>
              </div>
              <div class="input-group">
                <div id="wrap"
                     style="display:none;border:1px solid;width:396px;height:300px;margin:5px 0;position:relative; overflow: hidden;">
                    <img src="//t1.daumcdn.net/localimg/localimages/07/postcode/320/close.png" tabindex="0"
                         id="btnFoldWrap" alt="우편번호 검색창 접기 버튼" role="button"
                         style="outline-color: red;cursor:pointer;position:absolute;right:0px;top:0px;z-index:1"
                         @click="foldDaumPostcode" @keyup.enter="foldDaumPostcode">
                </div>
              </div>
              <div class="input-area wid100p">
                <input type="text" ref="addr1" v-model="addr1" title="기본주소" readonly>
              </div>
              <div class="input-area wid100p">
                <input type="text" id="addr2" ref="addr2" v-model="addr2" title="상세주소 입력" aria-label="상세주소" v-on:keyup="checked">
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><label for="joinChannel">가입경로</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span></th>
          <td>
            <div class="input-area mo-size wid400">
              <select title="가입경로" id="joinChannel" v-model="channel" v-on:change="channelChange" >
                <option value="지인소개">지인소개</option>
                <option value="50+재단/캠퍼스/센터">50+재단/캠퍼스/센터</option>
                <option value="서울시 유관홈페이지">서울시 유관홈페이지</option>
                <option value="언론보도">언론보도(신문, 방송, 라디오 등)</option>
                <option value="옥외광고">옥외광고(지하철, 버스, 현수막 등)</option>
                <option value="타 기관 안내">타 기관 안내</option>
                <option value="홍보책자">홍보책자(포스터, 전단지, 리플릿 등)</option>
                <option value="인터넷/SNS 검색">인터넷/SNS 검색(페이스북 등)</option>
                <option value="미디어광고">미디어광고(신문잡지, 라디오광고 등)</option>
                <option value="etc">기타</option>
              </select>
            </div>
            <div class="input-area mo-size wid400">
              <input type="text" id="joinChannelEtc" v-model="channelEtc" v-if="channel === 'etc'" maxlength="30" placeholder="입력해주세요."
                     title="가입경로 기타 입력" v-on:keyup="checked">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <label for="joinMotive">가입동기 및<br>희망분야</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span>
          </th>
          <td>
            <div class="input-area mo-size wid400">
              <select title="가입동기 및 희망분야" v-model="motive" id="joinMotive" v-on:change="motiveChange">
                <option value="인생후반전 준비에 대한 인식을 가지고자">인생후반전 준비에 대한 인식을 가지고자</option>
                <option value="사회공헌 및 자원봉사에 관심이 있어서">사회공헌 및 자원봉사에 관심이 있어서</option>
                <option value="NGO 등 인생후반전을 위한 단체를 구성하기 위해서">NGO 등 인생후반전을 위한 단체를 구성하기 위해서</option>
                <option value="창업을 위해서">창업을 위해서</option>
                <option value="재취업을 위해서">재취업을 위해서</option>
                <option value="생각이나 취미가 같은 사람들을 만나기 위해">생각이나 취미가 같은 사람들을 만나기 위해</option>
                <option value="etc">기타</option>
              </select>
            </div>
            <div class="input-area mo-size wid400">
              <input type="text" name="" v-model="motiveEtc" id="joinMotiveEtc" v-if="motive === 'etc'"
                     maxlength="30" placeholder="입력해주세요." title="가입동기 및 희망분야 기타 입력" v-on:keyup="checked">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" id="label-interest-orgs">나의<br class="mo-only"> 관심 50+<br>기관 <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span></th>
          <td>
            <div class="interest-grid" role="group" aria-labelledby="label-interest-orgs">
              <div class="check-wrap">
                <input type="checkbox" class="sr-only" id="like-orgs" v-model="allCheck" name="inlineRadioOptions" @click="chkAllOrgs"
                       aria-label="나의 관심 50+ 기관, 전체">
                <label for="like-orgs">
                  <span>전체</span>
                </label>
              </div>
              <div class="check-wrap" v-for="org in likeOrgCheckBoxList" :key="org.code">
                <input type="checkbox" class="sr-only" v-model="likeOrgs" :value="org.code" :aria-label="'나의 관심 50+ 기관, ' + org.name" :id="'like_'+org.code">
                <label :for="'like_'+org.code">
                  <span>{{ org.name }}</span>
                </label>
              </div>
            </div>
            <p class="interest-note mt-16">*관심 50+ 기관의 소식(문자, 뉴스레터)을 받을 수 있습니다.</p>
          </td>
        </tr>
        <tr>
          <th scope="row"><label for="occuPationSelect">주된 직업군<br>(퇴직자 포함)</label> <span class="must" aria-hidden="true">*</span><span class="sr-only">(필수입력)</span></th>
          <td>
            <div class="input-area wid100p">
              <select id="occuPationSelect" v-model="occuPationStr" @change="onOccuPationChange" title="주된 직업군 선택">
                <option value="">선택하세요</option>
                <option v-for="(occu, index) in occuList" :value="occu" :key="index" :title="occu">
                  {{ occu }}
                </option>
              </select>
            </div>
            <div class="input-area mo-size mt-8">
              <input type="text" size="12" maxlength="12" id="occuEtc" v-if="occuPationStr === '기타'" v-model="occuEtcVal"
                     v-on:keyup="checked" title="주된 직업군 기타 내용 입력란">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row" id="label-email-receive">Email 수신</th>
          <td>
            <div class="flex gap10" role="group" aria-labelledby="label-email-receive">
              <label class="radio-item" v-for="(key, value) in emailCheckList" :key="value">
                <input type="radio" class="sr-only" name="inlineRadioOptions1" v-model="emailCheck" :value="value" :aria-label="'Email 수신 여부, ' + key">
                <span class="custom-radio"></span>
                {{ key }}
              </label>
            </div>
            <span style="margin-top:5px;">*수신에 동의하시면, 맞춤형 정보를 담은<br/> 재단의 '월간 든든레터'를 받아보실 수 있습니다.</span>
          </td>
        </tr>
        <tr>
          <th scope="row" id="label-sms-receive">SMS 수신</th>
          <td>
            <div role="group" aria-labelledby="label-sms-receive" class="flex gap10">
              <label class="radio-item" v-for="(key, value) in smsCheckList" :key="value">
                <input type="radio" class="sr-only" name="inlineRadioOptions2" v-model="smsCheck" :value="value" :aria-label="'SMS 수신 여부, ' + key">
                <span class="custom-radio"></span>
                {{ key }}
              </label>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="button-area flex-justify-center mt-32">
        <a href="javascript:void(0)" class="btn btn-primary wid100p  btn-md" role="button" @click="join" title="가입하기">
          가입하기
        </a>
      </div>
    </div>
  </div>
</template>
<script>
/* global daum, tnkTrans, NScriptConv */
import Axios from 'axios';

const occuList = [
  '경영/금융/사무/보험',
  '공무원(교사)',
  '교육/강사/연구/법률',
  '의료/보건/사회복지',
  '마케팅/무역',
  '전문직(의사/변호사 등)',
  '문화/예술/신문방송/디자인',
  '영업/판매/고객상담/CS',
  '건설/건축/환경/산업',
  'IT/정보통신/웹',
  '숙박/음식/여행/스포츠/경비청소',
  '전업주부',
  '무직',
  '기타',
];

const genderList = {
  M: '남성',
  F: '여성',
};

const emailCheckList = {
  Y: '수신',
  N: '거부',
};

const smsCheckList = {
  Y: '수신',
  N: '거부',
};

const emailList = [
  'naver.com',
  'hanmail.net',
  'daum.net',
  'gmail.com',
  'google.com',
  'nate.com',
  'yahoo.com',
  'paran.com',
  'korea.com',
  'freechal.com',
];


const joinPurposeList = [
  '인생후반전 준비에 대한 인식을 가지고자',
  '사회공헌 및 자원봉사에 관심이 있어서',
  'NGO 등 인생후반전을 위한 단체를 구성하기 위해서',
  '창업을 위해서',
  '재취업을 위해서',
  '생각이나 취미가 같은 사람들을 만나기 위해',
];
const applyPathList = [
  '서울시 유관홈페이지',
  '언론보도',
  '홍보책자',
  '옥외광고',
  '미디어광고',
  '인터넷/SNS 검색',
  '타 기관 안내',
  '50+재단/캠퍼스/센터',
  '지인소개',
];

export default {
  name: 'member-regist',
  props: ['orgList', 'orgCode', 'sessionYear', 'sessionHp'],
  data() {
    return {
      birthYYYY: '',
      years: Array.from({length: 2020}, (v, i) => i).slice(1919),
      birthMM: '',
      months: Array.from({length: 13}, (v, i) => i).slice(1),
      birthDD: '',
      days: Array.from({length: 32}, (v, i) => i).slice(1),
      emailList,
      joinPurposeList,
      applyPathList,
      genderList,
      allCheck: false,
      aleadyHave: true,
      loginid: '',
      password: '',
      passwordConfirm: '',
      name: '',
      email1: '',
      email2: '',
      etcEmailAddress: '',
      email: '',
      birthdate: '',
      phone1: '010',
      phone2: '',
      phone3: '',
      addr1: '',
      addr2: '',
      zipcode: '',
      gender: '',
      applyPath: '',
      joinPurpose: '',
      likeOrgs: [],
      occuPation: [],
      occuPationStr: '',
      channel: '',
      channelEtc: '',
      motive: '',
      motiveEtc: '',
      isAgree: false,
      loggedIn: false,
      getMyDataPage: false,
      showFacebookUser: false,
      termAgree: '',
      thirdPartyAgree: '',
      privacyAgree: '',
      privacyAgree2: '',
      privacyAgree3: '',
      privacyAgree4: '',
      thirdPartyUseAgree: '',
      resumeAgree: '',
      bothAgree: '',
      userOrg: '',
      userId: '',
      userPassword: '',
      userName: '',
      userEmail: '',
      userPhone: '',
      transferDataList: [],
      facebookUser: false,
      myDataConfirmPage: false,
      occuList,
      occuEtcVal: '',
      emailCheck: 'Y',
      smsCheck: 'Y',
      emailCheckList,
      smsCheckList,
      joinChk: 'N',
      allAgree: false,
    };
  },
  watch: {
    loginid() {
      this.aleadyHave = true;
    },
    allAgree: {
      handler(newVal) {
        if (newVal === 'true') {
          this.termAgree = 'true';
          this.privacyAgree = 'true';
          this.privacyAgree2 = 'true';
          this.privacyAgree3 = 'true';
          this.privacyAgree4 = 'true';
          this.thirdPartyAgree = 'true';
          this.resumeAgree = 'true';
        } else {
          this.termAgree = 'false';
          this.privacyAgree = 'false';
          this.privacyAgree2 = 'false';
          this.privacyAgree3 = 'false';
          this.privacyAgree4 = 'false';
          this.thirdPartyAgree = 'false';
          this.resumeAgree = 'false';
        }
      }
    }
  },
  computed: {
    likeOrgCheckBoxList() {
      return this.orgList.filter((org) => org.code !== 'fpp' && org.code !== 'jpp' && org.code !== 'dsc');
    },
  },
  methods: {

    checked(event) {
      if (event.key === "'") {
        alert("'는 사용 하실 수 없습니다.");
        this.channelEtc = this.channelEtc.replace("'", '');
        this.motiveEtc = this.motiveEtc.replace("'", '');
        this.occuEtcVal = this.occuEtcVal.replace("'", '');
        this.addr2 = this.addr2.replace("'", '');
      }
    },
    agreeConfirm() {
      this.$nextTick(() => {
        // 필수 동의 항목 (선택 항목 privacyAgree2~4는 검증 대상 아님)
        // label: 화면 라벨과 동일한 약관 항목명(폴백) / DOM 조회 실패 시에도 alert에 노출
        const requiredAgrees = [
          { id: 'termAgree', checked: this.termAgree === 'true', ref: 'termAgree', label: '[필수] 홈페이지 이용약관 동의' },
          { id: 'privacyAgree', checked: this.privacyAgree === 'true', ref: 'privacyAgree', label: '[필수] 개인정보 수집 및 이용 동의(필수사항)' },
          { id: 'thirdPartyAgree', checked: this.thirdPartyAgree === 'true', ref: 'thirdPartyAgree', label: '[필수] 개인정보의 제3자 제공 동의' },
          { id: 'resumeAgree', checked: this.resumeAgree === 'true', ref: 'resumeAgree', label: '[필수] 나의 이력서 정보 제공 동의' },
        ];

        // 웹접근성: 첫 번째 미체크 필수 항목의 라벨 내용만 alert에 명시하고 해당 항목으로 초점 이동
        const unchecked = requiredAgrees.filter((item) => !item.checked);

        if (unchecked.length > 0) {
          const first = unchecked[0];
          // DOM 라벨 텍스트를 우선 사용(약관 문구 변경 자동 반영), 비어 있으면 명시 라벨로 폴백
          const labelEl = document.querySelector('label[for="' + first.id + '"]');
          const domText = labelEl ? labelEl.textContent.replace(/\*/g, '').replace(/\s+/g, ' ').trim() : '';
          const labelText = domText || first.label;
          alert('다음 필수 동의 항목에 체크해야 회원가입을 진행할 수 있습니다.\n\n- ' + labelText);
          // 첫 번째 미체크 항목으로 초점 이동
          const firstRef = this.$refs[first.ref];
          if (firstRef) {
            firstRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstRef.focus();
          }
        } else {
          this.isAgree = true;
          this.$nextTick(() => {
            const skipLink = document.querySelector('ul.skip a[href="#visual-box"]');
            if (skipLink) {
              skipLink.focus();
            }
          });
        }
        document.title = '회원가입 - 정보입력 | 서울시 50플러스포털';
      });
    },
    dateFormat(date) {
      return `20${date.slice(0, 2)}.${date.slice(2, 4)}.${date.slice(4)}`;
    },
    orgChange() {
      if (this.userOrg === 'swc' || this.userOrg === 'scc') {
        this.showFacebookUser = true;
      } else {
        this.showFacebookUser = false;
        this.facebookUser = false;
      }
    },
    getMyData() {
      const nameReg = /^[가-힣]{2,}$/g;
      if (!this.userOrg) {
        alert('기관을 선택해 주세요.');
      } else if (this.facebookUser) {
        if (!this.userName) {
          alert('이름을 입력해 주세요.');
        } else if (!nameReg.test(this.name)) {
          alert('이름은 한글 2자 이상, 공백은 포함되지 않아야 합니다.');
          $('#userName').focus();
        } else if (!this.userEmail) {
          alert('이메일을 입력해 주세요.');
        } else if (!this.userPhone) {
          alert('연략처를 입력해 주세요.');
        } else {
          const Params = {
            org: this.userOrg,
            userName: this.userName,
            userEmail: this.userEmail,
            userPhone: this.userPhone,
            facebookUser: this.facebookUser,
          };
          Axios.post('/api/members/transfer-with-regist', Params).then((res) => {
            this.transferDataList = res.data;
            this.myDataConfirmPage = true;
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      } else if (!this.userId) {
        alert('아이디를 입력해 주세요.');
      } else if (!this.userPassword) {
        alert('비밀번호를 입력해 주세요.');
      } else {
        const Params = {
          org: this.userOrg,
          userId: this.userId,
          userPassword: this.userPassword,
        };
        Axios.post('/api/members/transfer-with-regist', Params).then((res) => {
          this.transferDataList = res.data;
          this.myDataConfirmPage = true;
        }).catch((e) => {
          alert(e.response.data.msg);
        });
      }
    },
    ChangeGetMyDataPage() {
      this.getMyDataPage = true;
      this.myDataConfirmPage = false;
      this.showFacebookUser = false;
      this.facebookUser = false;
      this.userOrg = '';
      this.userId = '';
      this.userPassword = '';
      this.userName = '';
      this.userEmail = '';
      this.userPhone = '';
    },
    confirmId() {
      if (this.loginid) {
        this.loginid = this.loginid.toLowerCase();
        const idReg = /^[a-z]+[a-z0-9]{4,19}$/g;
        if (!idReg.test(this.loginid.toLowerCase())) {
          alert('아이디는 영문자로 시작하는 5~20자 영문자 또는 숫자이어야 합니다.');
          $('#loginid').focus();
        } else if (this.loginid.indexOf('admin') !== -1 ||
            this.loginid.indexOf('help') !== -1 ||
            this.loginid.indexOf('webmaster') !== -1 ||
            this.loginid.indexOf('administrator') !== -1 ||
            this.loginid.indexOf('50plus') !== -1 ||
            this.loginid.indexOf('master') !== -1) {
          alert('사용하실 수 없는 아이디입니다.');
          $('#loginid').focus();
        } else {
          Axios.get(`/api/members/exists?loginid=${this.loginid}`).then((res) => {
            const result = res.data;
            this.aleadyHave = res.data;
            if (result) {
              alert('사용중인 아이디입니다.');
            } else {
              alert('사용 가능합니다.');
            }
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      } else {
        alert('아이디를 입력해주세요.');
      }
    },
    join() {
      const idReg = /^[a-z]+[a-z0-9]{4,19}$/g;
      const pwdReg = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^*()\-_=+\\|[\]{};:'",.<>/?~`&]).{9,50}$/i;
      const emailReg = /^[a-zA-Z0-9._-]+$/;
      const email2 = this.email2 !== 'etc' ? this.email2 : this.etcEmailAddress;
      const nameReg = /^[가-힣]{2,}$/g;
      const indEmail = this.etcEmailAddress.indexOf('@');
      const lenEmail = this.etcEmailAddress.length;
      const pwdFirReg = /^[a-z]$/;
      const phoneReg = /^[0-9]+$/;
      if (indEmail > 0) {
        this.etcEmailAddress = this.etcEmailAddress.substring(indEmail + 1, lenEmail);
      }
      const firPwd = this.password.substring(0, 1);
      if (this.joinChk === 'Y') {
        alert('처리중 입니다.');
      } else if (this.aleadyHave) {
        alert('아이디 중복확인를 진행해주세요');
      } else if (!this.loginid) {
        alert('아이디를 입력해 주세요.');
        $('#loginid').focus();
      } else if (!idReg.test(this.loginid)) {
        alert('아이디는 영문자로 시작하는 6~20자 영문자 또는 숫자이어야 합니다.');
        $('#loginid').focus();
      } else if (this.loginid.indexOf('admin') !== -1 || this.loginid.indexOf('help') !== -1 || this.loginid.indexOf('webmaster') !== -1 || this.loginid.indexOf('administrator') !== -1 || this.loginid.indexOf('50plus') !== -1 || this.loginid.indexOf('master') !== -1) {
        alert('사용하실 수 없는 아이디입니다.');
        $('#loginid').focus();
      } else if (!this.email1 || !email2) {
        alert('이메일을 입력해 주세요.');
        $('#email1').focus();
      } else if (!emailReg.test(this.email1)) {
        alert('이메일을 형식을 확인해 주세요.');
        $('#email1').focus();
      } else if (!this.name) {
        alert('이름을 입력해 주세요.');
      } else if (!nameReg.test(this.name)) {
        alert('이름은 한글 2자 이상, 공백은 포함되지 않아야 합니다.');
        $('#userName').focus();
      } else if (!this.password || !this.passwordConfirm) {
        alert('비밀번호를 입력해 주세요.');
      } else if (this.password !== this.passwordConfirm) {
        alert('비밀번호를 확인해 주세요.');
      } else if (!pwdReg.test(this.password)) {
        alert('비밀번호는 영문(소문자), 숫자, 특수문자 포함 9자 이상이어야 합니다.');
        $('#password').focus();
      } else if (!pwdFirReg.test(firPwd)) {
        alert('비밀번호는 영문 소문자로 시작해주세요.');
        $('#password').focus();
      } else if (this.password.indexOf(this.loginid) !== -1) {
        alert('비밀번호는 아이디를 포함할 수 없습니다.');
        $('#password').focus();
      } else if (!this.birthYYYY) {
        alert('생년월일의 년도를 선택해 주세요.');
        $('#birthYYYY').focus();
      } else if (!this.birthMM) {
        alert('생년월일의 월을 선택해 주세요.');
        $('#birthMM').focus();
      } else if (!this.birthDD) {
        alert('생년월일의 일을 선택해 주세요.');
        $('#birthDD').focus();
      } else if (!this.gender) {
        alert('성별을 선택해주세요.');
      } else if (!this.phone1 || !this.phone2 || !this.phone3) {
        alert('휴대폰을 입력해 주세요.');
      } else if (
          !phoneReg.test(this.phone1) ||
          !phoneReg.test(this.phone2) ||
          !phoneReg.test(this.phone3)
      ) {
        alert('휴대폰입력란은 숫자로 입력해 주세요.');
      } else if (!this.zipcode || !this.addr1 || !this.addr2) {
        alert('주소를 입력해 주세요.');
      } else if (!this.channel) {
        alert('가입경로를 선택해 주세요.');
        $('#joinChannel').focus();
      } else if (!this.motive) {
        alert('가입동기 및 희망분야를 선택해 주세요.');
        $('#joinMotive').focus();
      } else if (!this.occuPationStr || this.occuPationStr === '') {
        alert('주된 직업군을 선택해 주세요.');
        $('select[v-model="occuPationStr"]').focus();
      } else if (!this.likeOrgs) {
        alert('나의 관심 50+를 최소 한 개의 선택이 필요합니다.');
        $('#like-orgs').focus();
      } else if (this.likeOrgs.length === 0) {
        alert('나의 관심 50+를 최소 한 개의 선택이 필요합니다.');
        $('#like-orgs').focus();
      } else {
        const year = this.birthYYYY;
        const month = this.birthMM < 10 ? 0 + this.birthMM : this.birthMM;
        const date = this.birthDD < 10 ? 0 + this.birthDD : this.birthDD;
        const yyyymmdd = year + month + date;
        const yymmdd = yyyymmdd.substr(2, 7);
        const channel = this.channel !== 'etc' ? this.channel : this.channelEtc;
        const motive = this.motive !== 'etc' ? this.motive : this.motiveEtc;
        const mail = `${this.email1}@${email2}`;
        const etc = this.occuPationStr.substring(0, 2);
        const privacyAgreeCon = this.privacyAgree2 === 'true' ? 'Y' : 'N';
        if (etc === '기타') {
          const front = '기타(';
          const end = ')';
          this.occuPationStr = front + document.getElementById('occuEtc').value + end;
        }
        const Params = {
          loginid: this.loginid.toLowerCase(),
          name: this.name,
          email: mail,
          birthdate: yymmdd,
          password: this.password,
          phone1: this.phone1,
          phone2: this.phone2,
          phone3: this.phone3,
          zipcode: this.zipcode,
          addr1: this.addr1,
          addr2: this.addr2,
          gender: this.gender,
          applyPath: channel,
          joinPurpose: motive,
          likeOrgs: this.likeOrgs,
          occuPation: this.occuPationStr,
          emailCheck: this.emailCheck,
          smsCheck: this.smsCheck,
          privacyAgree: privacyAgreeCon,
        };
        this.joinChk = 'Y';
        Axios.post('/api/members/regist', Params).then(() => {
          this.joinChk = 'N';
          tnkTrans();
          alert('회원가입이 완료되었습니다.');
          NScriptConv();
          location.href = '/join-complete.do';
        }).catch((e) => {
          this.joinChk = 'N';
          alert(e.response.data.msg);
        });
      }
    },
    motiveChange() {
      if (this.motive === 'etc') {
        document.getElementById('joinMotiveEtc').style.display = 'block';
      } else {
        document.getElementById('joinMotiveEtc').style.display = 'none';
      }
    },
    emailChange() {
      if (this.email2 === 'etc') {
        document.getElementById('emailSelectBoxDirect').style.display = 'block';
      } else {
        document.getElementById('emailSelectBoxDirect').style.display = 'none';
      }
    },
    channelChange() {
      if (this.channel === 'etc') {
        document.getElementById('joinChannelEtc').style.display = 'block';
      } else {
        document.getElementById('joinChannelEtc').style.display = 'none';
      }
    },
    chkAllOrgs() {
      if (this.allCheck) {
        this.orgCode.forEach((item) => {
          this.likeOrgs.push(item);
        });
      } else {
        this.likeOrgs = [];
      }
    },
    foldDaumPostcode() {
      const elementWrap = document.getElementById('wrap');
      // iframe을 넣은 element를 안보이게 한다.
      elementWrap.style.display = 'none';
    },
    onOccuPationChange() {
      // 직업군 선택 시 처리 (필요한 경우 추가 로직)
      console.log('선택된 직업군:', this.occuPationStr);
    },
    findAddress() {
      const thisVal = this;
      const elementWrap = document.getElementById('wrap');
      // 현재 scroll 위치를 저장해놓는다.
      const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      daum.postcode.load(() => {
        new daum.Postcode({
          oncomplete(data) {
            // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

            // 각 주소의 노출 규칙에 따라 주소를 조합한다.
            // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
            let fullAddr = data.address; // 최종 주소 변수
            let extraAddr = ''; // 조합형 주소 변수

            // 기본 주소가 도로명 타입일때 조합한다.
            if (data.addressType === 'R') {
              // 법정동명이 있을 경우 추가한다.
              if (data.bname !== '') {
                extraAddr += data.bname;
              }
              // 건물명이 있을 경우 추가한다.
              if (data.buildingName !== '') {
                extraAddr += (extraAddr !== '' ? `,${data.buildingName}` : data.buildingName);
              }
              // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
              fullAddr += (extraAddr !== '' ? `(${extraAddr})` : '');
            }

            // 우편번호와 주소 정보를 해당 필드에 넣는다.
            // 5자리 새우편번호 사용
            // document.getElementById('postcode').value = data.zonecode;
            thisVal.addr1 = fullAddr;
            thisVal.zipcode = data.zonecode;
            thisVal.$refs.addr1.focus();
            // iframe을 넣은 element를 안보이게 한다.
            // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
            elementWrap.style.display = 'none';

            // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
            document.body.scrollTop = currentScroll;
          },

          // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
          onresize(size) {
            elementWrap.style.height = `${size.height}px`;
          },
          width: '100%',
          height: '100%',
        }).embed(elementWrap);
      });
      // iframe을 넣은 element를 보이게 한다.
      elementWrap.style.display = 'block';
      setTimeout(() => {
        const fst = document.getElementById('wrap').childNodes[1];
        const snd = fst.firstChild;
        snd.title = '주소검색 입력창 아이프레임';
        // 닫기 버튼을 iframe 뒤(wrap 마지막)로 이동해 탭 순서를 검색어 입력 다음으로 정렬
        const closeBtn = document.getElementById('btnFoldWrap');
        if (closeBtn) {
          elementWrap.appendChild(closeBtn);
        }
      }, 1000);
    },
    initBirth() {
      this.birthYYYY = this.sessionYear.substring(0, 4);
      this.birthMM = this.sessionYear.substring(4, 6);
      if (this.birthMM.substring(0, 1) === '0') {
        this.birthMM = this.birthMM.substring(1, 2);
      }
      this.birthDD = this.sessionYear.substring(6, 8);
      if (this.birthDD.substring(0, 1) === '0') {
        this.birthDD = this.birthDD.substring(1, 2);
      }
    },
    initHp() {
      this.phone1 = this.sessionHp.substring(0, 3);
      this.phone2 = this.sessionHp.substring(3, 7);
      this.phone3 = this.sessionHp.substring(7, 11);
    },
  },
  mounted() {
    this.initBirth();
    if (this.sessionHp !== '') {
      this.initHp();
    }
  },
};
</script>

<style scoped>
/** 주소: 우편번호·기본주소 readonly 시 색상 외 패턴(점선)·아이콘(잠금)으로 구분 */
.address-wrap input[readonly] {
    color: #222 !important;
    -webkit-text-fill-color: #222;
    opacity: 1;
    /* 색상만이 아닌 외곽선 패턴(점선)으로 '직접 입력 불가' 구분 */
    border: 1px dashed #767676;
    background-color: #f2f2f2;
    /* 주변정보: 잠금 아이콘으로 비활성 입력란임을 인지 */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23767676' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='11' width='18' height='11' rx='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    padding-right: 30px;
}

/* 약관·정보입력 단계 체크박스: 체크 시 테두리 선 제거 (미체크 시 테두리는 유지) */
.check-wrap input[type="checkbox"]:checked + label:before {
    border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// MemberRegist.vue?5ddc07e4